const DATA_PLANE_QUEUE_EXT_POINT_PREFIX = 'dataplaneEventsQueue';
const DESTINATIONS_QUEUE_EXT_POINT_PREFIX = 'destinationsEventsQueue';
const DMT_EXT_POINT_PREFIX = 'transformEvent';

export {
  DATA_PLANE_QUEUE_EXT_POINT_PREFIX,
  DESTINATIONS_QUEUE_EXT_POINT_PREFIX,
  DMT_EXT_POINT_PREFIX,
};
